// index.js atau file entry point lainnya
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

const rootElement = document.getElementById("root");

// Mengecek apakah versi React yang digunakan mendukung Root API
if (ReactDOM.createRoot) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Jika tidak mendukung Root API, menggunakan pendekatan render tradisional
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement
  );
}
